var TabQrCodeModule = /** @class */ (function () {
    function TabQrCodeModule() {
    }
    return TabQrCodeModule;
}());
export { TabQrCodeModule };
